import configManager from '../config/configManager';

const YS_IMAGE_HOST = configManager.get('BASE_API');
/**
 * ys缩略图封装
 * @param {String} url 网络图片地址
 * @param {Object} options 处理参数
 * @return {String}
 */
export function ysImageThumb(
  url,
  options = {
    //缩放 resize 参数
    l: null, //指定目标缩略图的最长边。 	1-4096
    s: null, //指定目标缩略图的最短边。 	1-4096
    w: null, //	指定目标缩略图的最长边。   1-4096
    h: null, //指定目标缩略图的高度。      1-4096
    q: 100 // 质量 1-100
  }
) {
  let { l, s, w, h, q } = options;
  let result = YS_IMAGE_HOST + '/open/Image/thumb?';
  result +=
    'url=' +
    encodeURIComponent(url) +
    (l ? '&l=' + l : '') +
    (s ? '&s=' + s : '') +
    (w ? '&w=' + w : '') +
    (h ? '&h=' + h : '') +
    (q ? '&q=' + q : '');
  return result;
}
/**
 * 获取图片信息 宽、高
 * @param {Object} url
 */
export async function ysImageInfo(url) {
  let uri = YS_IMAGE_HOST + '/open/Image/info?';
  uri += 'url=' + encodeURIComponent(url);
  const [error, result] = await uni.request({
    url: uri
  });
  return result;
}
